import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import AuthService from "../services/authService";

const Signin = () => {
    document.title = "Sign in | Shortener";
    const authService = new AuthService();
    const history = useHistory();
    const signing = authService.storage.getItem("signing-in") === "true";

    const signIn = () => {
        authService.storage.removeItem("authenticated");
        authService.loginRedirect();
    };

    useEffect(() => {
        if (!signing) { signIn(); }

        setTimeout(() => {
            if (authService.storage.getItem("authenticated") === "true") {
                authService.storage.removeItem("signing-in");
                history.push("/");
            }
        }, 2000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    return (
        <div style={{ textAlign: "center", marginTop: 50 }}>
            {signing && <div>Validating user...</div>}
        </div>
    );
};

export default Signin;
